import { render, staticRenderFns } from "./four.vue?vue&type=template&id=04d7f7cf&scoped=true&"
import script from "./four.vue?vue&type=script&lang=js&"
export * from "./four.vue?vue&type=script&lang=js&"
import style0 from "./four.vue?vue&type=style&index=0&id=04d7f7cf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7f7cf",
  null
  
)

export default component.exports